var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2179_2341)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.4433 5.772H7.0526C5.36726 5.76498 3.98576 7.22034 3.94606 9.04524V18.4489C3.90879 20.3037 5.26597 21.8407 6.97805 21.8819C7.00317 21.8819 7.02748 21.8828 7.0526 21.8819H13.5258C15.2224 21.8073 16.5594 20.2887 16.5472 18.4489V10.4032L12.4433 5.772Z",
    stroke: "#888",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.2266 5.76172V8.31518C12.2266 9.56163 13.1567 10.572 14.3073 10.5755H16.5396",
    stroke: "#888",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0785 16.829H7.70312",
    stroke: "#888",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4224 13.5356H7.70312",
    stroke: "#888",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.2799 1.5H16.2794L16.2799 2.25C16.2794 1.5 16.2794 1.5 16.2794 1.5H16.2792H16.2783L16.2749 1.5L16.2616 1.50001L16.2096 1.50004L16.0121 1.50015L15.3074 1.50055L13.168 1.50176L11.0269 1.50296L10.3199 1.50336L10.1209 1.50347L10.0681 1.5035L10.0543 1.50351L10.0498 1.50351V1.50349L10.0448 1.50353C8.73913 1.51224 7.62268 1.98837 6.83996 2.8694C6.49228 3.26074 6.22274 3.71789 6.03125 4.22544H7.69401C7.77536 4.09423 7.86484 3.97426 7.96133 3.86565C8.42969 3.33847 9.12304 3.01022 10.0526 3.00351L13.1689 3.00176L15.3082 3.00055L16.013 3.00015L16.2104 3.00004L16.2624 3.00001L16.2758 3L16.2792 3L16.2799 3L16.28 3L16.2801 3L16.2802 3C17.2202 3.00008 17.9203 3.32742 18.3927 3.85555C18.8735 4.39316 19.1817 5.21122 19.1817 6.29394V14.366C19.1817 15.4428 18.8759 16.2576 18.3987 16.7947C18.2728 16.9364 18.1307 17.0637 17.9722 17.1743V18.8585C18.5712 18.6288 19.0949 18.2696 19.5201 17.791C20.2947 16.9191 20.6817 15.7207 20.6817 14.366V6.29394C20.6817 4.93291 20.2919 3.72901 19.5107 2.85558C18.7212 1.97275 17.5954 1.5 16.2799 1.5Z",
    fill: "#888"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2179_2341"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.cb87f2c6e721b420f1bae7d6a7884b28.svg";
export { ForwardRef as ReactComponent };